// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eSU-v","message":"styles_message__1jMvi"};